import Vue from 'vue';
import { VForm } from '@/typeassist';
import ResetPasswordService from '@/ResetPasswordService';
import ErrorHelper from '@/ErrorHelper';
import RegistrationService from '@/RegistrationService';
import router from '@/routing';
import PasswordHelper from './PasswordHelper';

export default Vue.extend({
    name: 'ResetPassword',

    components: {

    },

    data: () => ({
        errorMessage: '',
        email: '',
        password: '',
        confirmpassword: '',
        loading: false,
        snackbar: false,
        snackbarText: '',
        snackbarColor: '',
        code: ''
    }),
    mounted: async function () {
        this.loading = true
        try {
            const code = this.$route.query.code
            if (!(code && (typeof (code) === 'string' || code instanceof String))) {
                throw new Error("Code query parameter not found")
            }
            this.code = code as string
            const resetPasswordInfo = await ResetPasswordService.resetPasswordInfo(this.code)
            this.email = resetPasswordInfo.data.email
        } catch (error) {
            console.error(error)
            ErrorHelper.ifUserError(error, (userError) => this.showError(userError)) ||
                this.showError('Error occurred. The code might have expired or be invalid.')
        } finally {
            this.loading = false
        }
    },
    methods: {

        showError: function (message: string) {
            this.snackbarText = message;
            this.snackbar = true
            this.snackbarColor = 'error'
        },
        showInfo: function (message: string) {
            this.snackbarText = message;
            this.snackbar = true
            this.snackbarColor = ''
        },
        async confirm() {
            if(!PasswordHelper.isValid(this.password, this.confirmpassword, this.showError))  {
                return
            }

            this.loading = true
            try {
                const resp = await ResetPasswordService.setPassword({
                    code: this.code,
                    newPassword: this.password
                })
                this.$router.replace('/setpasswordsuccess')
            }
            catch (error) {
                ErrorHelper.ifUserError(error, (userError) => this.showError(userError)) ||
                    this.showError('Error occurred resetting the password. Please try again, or request another code.')
            }

        }
    }
})
